import React, { Fragment } from 'react'
import { TableCell, TableRow } from '@material-ui/core'
import NumberFormat from 'react-number-format';


const RegisterAogMog = props => {
  const { registerAogMog } = props
  return (
    <Fragment>
      <TableRow key={registerAogMog.register_aog_mog.id}>
        <TableCell>
          {registerAogMog.register_aog_mog.tanggal_pendaftaran}
        </TableCell>
        <TableCell>
          {registerAogMog.register_aog_mog.nama_lengkap}
        </TableCell>
        <TableCell>
          {registerAogMog.register_aog_mog.jenis_pendaftaran}
        </TableCell>
        <TableCell>
          {registerAogMog.register_aog_mog.cabang_pembina}
        </TableCell>
        <TableCell>
          {registerAogMog.register_aog_mog.nama_pereferal}
        </TableCell>
        <TableCell>
          <NumberFormat thousandSeparator={'.'} prefix={'Rp.'} decimalSeparator={','} displayType={'text'} value={registerAogMog.biaya_upgrade}/>
        </TableCell>
      </TableRow>
    </Fragment>
  )
}

export default RegisterAogMog
